export default {
  'consumables.entity.name': 'Nome',
  'consumables.entity.barCode': 'Código de Barras',
  'consumables.entity.manufacturer': 'Fabricante',
  'consumables.entity.sku': 'Cód. Interno',
  'consumables.entity.manufacturerCode': 'Cód. Fabricante',
  'consumables.entity.lifeSpan': 'Vida útil (dias)',
  'consumables.entity.cfop': 'CFOP',
  'consumables.entity.ncm': 'NCM',
  'consumables.entity.unit': 'Unidade',
  'consumables.entity.subGroup': 'Grupo',
  'consumables.entity.comment': 'Observações',
  'consumables.entity.addConsumableImage': 'Adicionar Imagem do Produto',

  'consumables.pageHeader.button.newConsumable': 'Novo Insumo',
  'consumables.list.header.manufacturingCode': 'Cod. do Fabricante',
  'consumables.list.header.name': 'Nome',
  'consumables.list.header.actions': 'Ações',
  'consumables.list.column.actions.button': 'Ver/Editar',

  'consumables.create': 'Criar Novo Insumo',
  'consumables.create.notifications.success.title': 'Sucesso',
  'consumables.create.notifications.success.description': 'Insumo criado.',

  'consumables.remove.confirm.title': 'Remover Insumo',
  'consumables.remove.confirm.content':
    'Deseja realmente remover o insumo selecionado?',
  'consumables.remove.success.message': 'Sucesso',
  'consumables.remove.success.description': 'Insumo removido.',

  'consumables.details': 'Detalhes do Insumo',

  'consumables.update': 'Editar Insumo',
  'consumables.update.notifications.success.title': 'Sucesso',
  'consumables.update.notifications.success.description': 'Insumo editado.',

  'consumables.stock': 'Estoque',
  'consumables.stock.domain.company': 'Empresa',
  'consumables.stock.domain.stock': 'Estoque',
  'consumables.stock.domain.availableStock': 'Estoque Disponível',
  'consumables.stock.domain.sellPrice': 'Preço de Venda',
  'consumables.stock.domain.minStock': 'Est. Mínimo',
  'consumables.stock.domain.maxStock': 'Est. Máximo',
  'consumables.stock.domain.buyPrice': '(R$) Pr. Custo',
  'consumables.stock.domain.ipi': '(%) IPI',
  'consumables.stock.domain.taxReplacement': '(R$) Subs. Tributária',
  'consumables.stock.domain.fixedCost': '(%) Custo Fixo',
  'consumables.stock.domain.icmsExemption': 'ICMS Deson.',
  'consumables.stock.domain.freightCost': '(R$) Valor Frete',
  'consumables.stock.domain.otherExpenses': '(R$) Outras Despesas',
  'consumables.stock.domain.realCost': 'Custo Real',
  'consumables.stock.domain.maxDiscount': '% Max. Desconto',
  'consumables.stock.domain.location': 'Localização',
  'consumables.stock.domain.profitMargin': '(%) Lucro',
  'consumables.stock.domain.operationalExpenses': '(%) Desp. Operacionais',
  'consumables.stock.domain.enabled': 'Habilitado',

  'consumables.lastPurchases.domain.code': 'Número da compra',
  'consumables.lastPurchases.domain.supplier': 'Fornecedor',
  'consumables.lastPurchases.domain.releaseDate': 'Data da compra',
  'consumables.lastPurchases.domain.quantity': 'Quantidade',
  'consumables.lastPurchases.domain.unitaryValue': 'Valor unitário',
  'consumables.lastPurchases.domain.totalAmountItem': 'Valor total',
  'consumables.lastPurchases.domain.averageCostLastPurchases':
    'Valor médio de custo do insumo nas últimas compras: ',

  'consumables.stock.enabledCostFields':
    'Para a empresa selecionada: {company}, os seguintes campos fazem parte do cálculo do "Custo Real"',

  'consumables.stock.update.notifications.success.title': 'Sucesso',
  'consumables.stock.update.notifications.success.description':
    'Configurações de estoque da empresa foram atualizadas.',

  'consumables.modal.report.title': 'Gerar Relatório',
  'consumables.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'consumables.modal.report.buttons.pdf': 'Gerar PDF',
  'consumables.modal.report.buttons.rtf': 'Gerar RTF',
  'consumables.modal.report.buttons.csv': 'Gerar CSV',
  'consumables.modal.report.form.description': 'Descrição, De',
  'consumables.modal.report.form.descriptionUpUntil': 'Até',
  'consumables.modal.report.form.group': 'Grupos',
  'consumables.modal.report.form.manufactures': 'Fabricantes',
  'consumables.modal.report.form.companies': 'Empresas',
  'consumables.modal.report.form.localization': 'Localização, De',
  'consumables.modal.report.form.localizationUpUntil': 'Até',

  'consumables.status.message.success':
    'Status do Insumo alterado com sucesso!',

  'consumables.error.alreadyExists':
    'Já existe um Insumo cadastrado com esse código interno ou código de barras',
  'consumables.error.remove.bonds':
    'Não foi possível concluir a ação devido a violação nos vínculos desse registro!',
};
